<template>
  <div>
    <!-- 删除文件 开始 -->
    <div class="in-delete">
      <i class="iconfont icon-sp_tixing"></i>
      <p>提醒</p>
      <p v-if="!modalInfo.length">确定要设置此版本为当前版本吗?</p>
      <el-button @click="deletefile">确定</el-button>
      <el-button @click="cancle">取消</el-button>
    </div>
    <!-- 删除文件 结束 -->
  </div>
</template>
<script>
import ApiService from '@/services/API-services'
export default {
  name: 'setcurrentfile',
  data() {
    return {
    }
  },
  props: {
    modalInfo: null
  },
  created() {
    console.log(this.modalInfo)
  },
  methods: {
    cancle() {
      this.$store.commit('closeModal', 'setcurrentfile')
    },
    // 删除文档
    deletefile() {
      let params = new FormData()
      params.append('module', 'VersionManager')
      params.append('fun', 'SetCurrentFileVersion')
      params.append('fileId', this.modalInfo.fileId)
      params.append('fileVerId', this.modalInfo.fileVerId)
      ApiService.oct_doc.common(params).then(res => {
        // console.log(res)
        this.$message({
          message: '设置成功',
          type: 'success'
        })
        this.cancle()
        this.$store.commit('reloadVision', this.modalInfo.fileId)
      })
    }
  }
}
</script>
<style lang="scss">
.in-delete {
  width: 398px;
  border-radius: 2px;
  position: absolute;
  background: #fff;
  top: 20%;
  left: 25%;
  padding: 30px 0;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  i {
    font-size: 50px;
    color: rgb(255, 162, 0);
  }

  p:nth-child(2) {
    color: #003580;
    font-family: "Microsoft YaHei-Bold";
    font-size: 18px;
  }

  p:nth-child(3) {
    margin-top: 10px;
    font-size: 14px;
    color: #333;
  }

  .el-button {
    width: 148px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    color: #fff;
    background: #2d61a8;
    border-radius: 2px;
    margin-top: 30px;
    padding: 0;
    border: 0;
  }
  i {
    color: rgb(242, 148, 23);
  }

  .el-button:last-child {
    background: #fff;
    border: 1px solid rgb(229, 229, 229);
    color: #999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mind/setCurrentFile.vue